import { render } from "./Card.vue?vue&type=template&id=2e84c32e&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=2e84c32e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e84c32e"]])

export default __exports__